export const AF_CHANNELS = [
  'inapp_display', 'inapp_banner', 'banner', 'inapp', 'display',
  'banner320X50', 'banner300X250', 'in-app', 'mobile_banner',
  'mobile_display', 'InApp_Display',
]

export const DEFAULT_RETARGETING = {
  af_reengagement_window: '30d',
  af_inactivity_window: '10d',
}

export const DEFAULT_ADVANCED = {
  af_siteid: '{pid}',
  af_c_id: '{offer_id}',
  af_click_lookback: '7d',
  af_viewthrough_lookback: '24h',
  clickid: '{clickid}',
  af_sub_siteid: '{sub6}',
  af_ad_type: 'banner',
  af_media_type: 'app',
  af_model: '{device_model}',
  af_cost_currency: 'usd',
  af_ua: '{device_ua}',
  af_ip: '{ip}',
  device_id: '{sub5}',
  af_os_version: '{os_version}',
  af_language: '{language}',
  af_ad_format: 'image',
  af_channel: '',
}

export const pickChannel = () => AF_CHANNELS[Math.floor(Math.random() * AF_CHANNELS.length)]

export const dateSuffix = () => {
  const now = new Date()
  const dd = String(now.getDate()).padStart(2, '0')
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const r = Math.floor(Math.random() * 10)
  return `${dd}${mm}${r}`
}

export const buildAdsetAd = (codes) => {
  const pool = [...codes]
  const i = Math.floor(Math.random() * pool.length)
  const adsetCode = pool.splice(i, 1)[0]
  const adCode = pool[Math.floor(Math.random() * pool.length)]
  const suffix = dateSuffix()
  return { adset: `${adsetCode}${suffix}`, ad: `${adCode}${suffix}` }
}

export const validateBundle = (os, raw) => {
  const v = raw.trim()
  if (!v) return 'Bundle ID is required.'
  if (os === 'ios') {
    if (!/^\d+$/.test(v)) return 'iOS expects the numeric App Store ID (digits only), e.g. 284882215.'
  } else if (!/^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z0-9_]+)+$/.test(v)) {
    return 'Android expects a package name, e.g. com.company.app.'
  }
  return ''
}

const pushParam = (p, key, value) => {
  const v = value == null ? '' : String(value).trim()
  if (v) p.push(`${key}=${v}`)
}

export const buildUrl = ({
  os,
  bundleId,
  agency,
  pid,
  channel,
  campaignName,
  costModel,
  isRetargeting,
  additionalParams,
  adset,
  ad,
  isVTA,
  advanced = {},
  reengagementWindow,
  inactivityWindow,
}) => {
  const host = isVTA ? 'https://impression.appsflyer.com/' : 'https://app.appsflyer.com/'
  const appPart = os === 'ios' ? 'id' + bundleId.trim() : bundleId.trim()
  const a = { ...DEFAULT_ADVANCED, ...advanced }

  const p = []
  p.push(`pid=${encodeURIComponent(pid)}`)
  if (agency.trim()) p.push(`af_prt=${encodeURIComponent(agency.trim())}`)
  pushParam(p, 'af_siteid', DEFAULT_ADVANCED.af_siteid)
  pushParam(p, 'af_c_id', DEFAULT_ADVANCED.af_c_id)
  if (isVTA) {
    pushParam(p, 'af_viewthrough_lookback', a.af_viewthrough_lookback)
  } else {
    pushParam(p, 'af_click_lookback', a.af_click_lookback)
  }
  pushParam(p, 'clickid', DEFAULT_ADVANCED.clickid)
  p.push(`c=${encodeURIComponent(campaignName.trim())}`)
  pushParam(p, 'af_sub_siteid', a.af_sub_siteid)
  pushParam(p, 'af_channel', channel)
  pushParam(p, 'af_ad_type', a.af_ad_type)
  p.push(`af_adset=${adset}{sub7}`)
  p.push(`af_adset_id=${adset}`)
  p.push(`af_ad=${ad}{sub2}`)
  p.push(`af_ad_id=${ad}`)
  pushParam(p, 'af_media_type', a.af_media_type)
  pushParam(p, 'af_model', a.af_model)
  pushParam(p, 'af_cost_currency', a.af_cost_currency)
  p.push(`af_cost_model=${costModel}`)
  pushParam(p, 'af_ua', a.af_ua)
  pushParam(p, 'af_ip', a.af_ip)
  pushParam(p, os === 'android' ? 'advertising_id' : 'idfa', a.device_id)
  pushParam(p, 'af_os_version', a.af_os_version)
  pushParam(p, 'af_language', a.af_language)
  p.push(`is_retargeting=${isRetargeting === 'yes' ? 'true' : 'false'}`)
  if (isRetargeting === 'yes') {
    pushParam(p, 'af_reengagement_window', reengagementWindow)
    pushParam(p, 'af_inactivity_window', inactivityWindow)
  }
  pushParam(p, 'af_ad_format', a.af_ad_format)

  let url = `${host}${appPart}?${p.join('&')}`
  const extra = additionalParams.trim().replace(/^[?&\s]+/, '')
  if (extra) url += '&' + extra
  return url
}
